import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../../api/agent";
import { ReportInput } from "../../models/reports";
import { PagingParams, Pagination } from "../../models/pagination";
import { DateRangeOption, ReportType } from "../../models/enums";
import { InventorySalesSummaryReportDto } from "../../models/inventoryReports";

export default class InventorySalesSummaryReportStore {
  constructor() {
    makeAutoObservable(this);
    reaction(
      () => this.predicate.keys(),
      () => {
        this.salesSummaryRegistry.clear();
        this.loadSalesSummaryReport();
      }
    );
  }

  loadingInitial = false;
  setLoadingInitial = (state: boolean) => {
    this.loadingInitial = state;
  };

  reportCriteria: ReportInput = new ReportInput({
    dateRange: DateRangeOption.Today,
    startDate: new Date(),
    endDate: new Date(),
    reportType: ReportType.Summary,
    filter: "0",
  });

  salesSummaryRegistry = new Map<string, InventorySalesSummaryReportDto>();

  resetSalesSummaryRegistry = () => {
    this.salesSummaryRegistry.clear();
  };

  loadSalesSummaryReport = async () => {
    this.loadingInitial = true;
    try {
      this.salesSummaryRegistry.clear();
      const result = await agent.inventoryReports.getInventorySalesSummary(this.axiosParams);
      runInAction(() => {
        result.forEach((salesSummaryReport) => {
          this.setSalesSummaryReport(salesSummaryReport);
        });
      });
    } catch (error) {
      console.log(error);
    } finally {
      this.setLoadingInitial(false);
    }
  };

  private setSalesSummaryReport = (salesSummaryReport: InventorySalesSummaryReportDto) => {
    this.salesSummaryRegistry.set(salesSummaryReport.id ?? "", salesSummaryReport);
  };

  get getInventorySalesSummaryReport() {
    return Array.from(this.salesSummaryRegistry.values()).sort(
      (a, b) => a.partNumber!.localeCompare(b.partNumber!)
    )
  }

  get groupedInventorySalesSummaryReport() {
    return Object.entries(
      this.getInventorySalesSummaryReport.reduce((groups, invSt) => {
  
        const name = `${
            invSt.vendorName 
            ? invSt.vendorName
            : "No Vendor Assigned"
        }`;

        groups[name] = groups[name] ? [...groups[name], invSt] : [invSt];
        return groups;
      }, {} as { [key: string]: InventorySalesSummaryReportDto[] })
    );
  }

  pagingParams = new PagingParams();
  pagination: Pagination | null = null;
  predicate = new Map().set("all", true);

  get axiosParams() {
    const params = new URLSearchParams();
    this.predicate.forEach((value, key) => {
      if (key === "StartDate" || key === "EndDate") {
        params.append(key, (value as Date).toISOString());
      } else {
        params.append(key, value);
      }
    });
    return params;
  }

  setPredicate = (startDate?: Date, endDate?: Date) => {
    const resetPredicate = () => {
      this.predicate.forEach((value, key) => {
        if (key !== "startDate") this.predicate.delete(key);
      });
    };
    resetPredicate();
    if (startDate) this.predicate.set("StartDate", startDate);
    if (endDate) this.predicate.set("EndDate", endDate);
  };

  setReportCriteria = (values: ReportInput) => {
    this.reportCriteria = new ReportInput(values);
  };

calculateTotalCosts = (data: InventorySalesSummaryReportDto[]) => {
    const summary = data.reduce(
    (accumulator: number, item: InventorySalesSummaryReportDto) => {
        accumulator += (item.retailSales ?? 0.0);
        return accumulator;
    }, 0);
    return summary;
};

}
